<template>
    <div>
        <Breadcrumb section-name="Expense" :breadcrumb="breadCrumb"></Breadcrumb>
        <div class="col-12">
            <div class="card mb-0">
                <div class="card-body" :class="{'data-loading': dataLoading}">
                    <form @submit.prevent="manage">
                        <div class="fixed-card-height">
                            <div class="card border-top border-0 border-4 border-primary">
                                <div class="card-body p-4">
                                    <div class="card-title d-flex align-items-center justify-content-between mb-0">
                                        <h5 class="mb-0 text-primary">{{ breadCrumb[0] }} Expense</h5>
                                    </div>
                                    <hr>
                                    <div class="row g-3">
                                        <div class="col-md-6 form-group">
                                            <label class="form-label">Project <span class="text-danger">*</span></label>
                                            <select class="form-select" v-model="addEditParam.project_id" name="project_id">
                                                <option value="">Select Project</option>
                                                <option v-for="c in projects" :key="c.id" :value="c.id">{{ c.name }}</option>
                                            </select>
                                            <small class="invalid-feedback text-danger"></small>
                                        </div>
                                        <div class="col-md-6 form-group">
                                            <label class="form-label">Date <span class="text-danger">*</span></label>
                                            <flat-pickr class="form-control" v-model="addEditParam.date" name="date"
                                                        :config="{dateFormat: 'Y-m-d', altInput: true, altFormat:'d/m/Y'}"
                                                        placeholder="Select Date"/>
                                            <small class="invalid-feedback text-danger"></small>
                                        </div>
                                        <div class="col-md-6 form-group">
                                            <label class="form-label">Payment Method <span class="text-danger">*</span></label>
                                            <select class="form-select" v-model="addEditParam.payment_method" name="payment_method">
                                                <option value="">Select Payment Method</option>
                                                <option v-for="each in assets" :key="each.slug" :value="each.slug">{{ each.name }}</option>
                                            </select>
                                            <small class="invalid-feedback text-danger"></small>
                                        </div>
                                        <div class="col-md-6 form-group" v-if="addEditParam.payment_method === 'bank'">
                                            <label class="form-label">Bank Name</label>
                                            <select class="form-select" v-model="addEditParam.bank_id" name="bank_id">
                                                <option value="">Select Bank</option>
                                                <option v-for="b in banks" :key="b.id" :value="b.id">{{ b.name }}</option>
                                            </select>
                                            <small class="invalid-feedback text-danger"></small>
                                        </div>
                                        <div class="col-md-6 form-group" v-if="addEditParam.payment_method === 'bank'">
                                            <label class="form-label">Check Number</label>
                                            <input type="text" class="form-control" name="check_number" v-model="addEditParam.check_number" placeholder="Enter check number">
                                            <small class="invalid-feedback text-danger"></small>
                                        </div>
                                        <div class="col-md-6 form-group">
                                            <label class="form-label">Purchase By</label>
                                            <select class="form-select" v-model="addEditParam.purchase_by" name="purchase_by" :disabled="!addEditParam.project_id">
                                                <option value="">{{ addEditParam.project_id ? 'Select Purchase By' : 'Select project first' }}</option>
                                                <option v-for="member in shareholders" :key="member.id" :value="member.id">{{ member.name }}</option>
                                            </select>
                                            <small class="invalid-feedback text-danger"></small>
                                        </div>
                                        <div class="col-md-6 form-group">
                                            <label class="form-label">Expense Category</label>
                                            <select class="form-select" v-model="addEditParam.category_id" name="category_id">
                                                <option value="">Select Category</option>
                                                <option v-for="a in expenseCategories" :key="a.id" :value="a.id">{{ a.name }}</option>
                                            </select>
                                            <small class="invalid-feedback text-danger"></small>
                                        </div>
                                        <div class="col-md-6 form-group">
                                            <label class="form-label">Supplier</label>
                                            <select class="form-select" v-model="addEditParam.supplier_id" name="supplier_id">
                                                <option value="">Select Supplier</option>
                                                <option v-for="a in suppliers" :key="a.id" :value="a.id">{{ a.name }}</option>
                                            </select>
                                            <small class="invalid-feedback text-danger"></small>
                                        </div>
                                        <div class="col-md-6 form-group">
                                            <label class="form-label">Raw Material</label>
                                            <select class="form-select" v-model="addEditParam.raw_material_id" name="raw_material_id">
                                                <option value="">Select Raw Material</option>
                                                <option v-for="each in rawMaterials" :key="each.id" :value="each.id">{{ each.name }}</option>
                                            </select>
                                            <small class="invalid-feedback text-danger"></small>
                                        </div>
                                        <div class="col-md-6 form-group">
                                            <label class="form-label">Unit Price</label>
                                            <input type="text" class="form-control" v-model="addEditParam.unit_price" name="unit_price" placeholder="Enter unit price">
                                            <small class="invalid-feedback text-danger"></small>
                                        </div>
                                        <div class="col-md-6 form-group">
                                            <label class="form-label">Quantity</label>
                                            <input type="text" class="form-control" v-model="addEditParam.quantity" name="quantity" placeholder="Enter quantity">
                                            <small class="invalid-feedback text-danger"></small>
                                        </div>
                                        <div class="col-md-6 form-group">
                                            <label class="form-label">Amount</label>
                                            <input type="text" class="form-control" disabled v-model="addEditParam.amount" name="amount" placeholder="Auto calculated">
                                            <small class="invalid-feedback text-danger"></small>
                                        </div>
                                        <div class="col-md-6 form-group">
                                            <label class="form-label">Special Expense</label>
                                            <select class="form-select" v-model="addEditParam.special_expense_id" name="special_expense_id">
                                                <option value="">Select Special Expense</option>
                                                <option v-for="each in specialExpense" :key="each.id" :value="each.id">{{ each.name }}</option>
                                            </select>
                                            <small class="invalid-feedback text-danger"></small>
                                        </div>
                                        <div class="col-md-6 form-group">
                                            <label class="form-label">Costing Item</label>
                                            <select class="form-select" v-model="addEditParam.costing_item_id" name="costing_item_id">
                                                <option value="">Select Costing Item</option>
                                                <option v-for="each in costingItem" :key="each.id" :value="each.id">{{ each.name }}</option>
                                            </select>
                                            <small class="invalid-feedback text-danger"></small>
                                        </div>
                                        <div class="col-md-6 form-group">
                                            <label class="form-label">Construction</label>
                                            <select class="form-select" v-model="addEditParam.construction_id" name="construction_id">
                                                <option value="">Select Construction</option>
                                                <option v-for="each in constructions" :key="each.id" :value="each.id">{{ each.name }}</option>
                                            </select>
                                            <small class="invalid-feedback text-danger"></small>
                                        </div>
                                        <div class="col-md-6 form-group">
                                            <label class="form-label">Order By</label>
                                            <input type="text" class="form-control" v-model="addEditParam.order_by" placeholder="Enter order by">
                                        </div>
                                        <div class="col-md-6 form-group">
                                            <label class="form-label">Attachment</label>
                                            <input type="file" class="form-control" @change="addAttachment">
                                            <small class="invalid-feedback text-danger"></small>
                                        </div>
                                        <div class="col-md-6 form-group">
                                            <label class="form-label">Remarks</label>
                                            <input type="text" class="form-control" v-model="addEditParam.remarks" placeholder="Enter remarks">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex justify-content-end gap-2 mt-3">
                            <router-link :to="{name: 'expense'}" class="btn btn-secondary btn-width">Close</router-link>
                            <button type="submit" class="btn btn-primary btn-width" v-if="!loading">Save</button>
                            <button type="button" class="btn btn-primary btn-width" v-else disabled>
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Breadcrumb from "../Common/Breadcrumb";
import ApiService from "../../Services/ApiService";
import ApiRoutes from "../../Services/ApiRoutes";

export default {
    components: {Breadcrumb},
    data() {
        return {
            breadCrumb: ['Add'],
            loading: false,
            dataLoading: false,
            addEditParam: {
                project_id: '',
                date: '',
                payment_method: '',
                bank_id: '',
                check_number: '',
                purchase_by: '',
                category_id: '',
                supplier_id: '',
                attachment: '',
                raw_material_id: '',
                unit_price: '',
                quantity: '',
                amount: '',
                remarks: '',
                special_expense_id: '',
                costing_item_id: '',
                construction_id: '',
                order_by: ''
            },
            shareholders: [],
            banks: [],
            projects: [],
            expenseCategories: [],
            rawMaterials: [],
            assets: [],
            suppliers: [],
            specialExpense: [],
            costingItem: [],
            constructions: []
        }
    },
    watch: {
        'addEditParam.project_id'(projectId, oldProjectId) {
            if (oldProjectId !== undefined && oldProjectId !== '' && String(oldProjectId) !== String(projectId)) {
                this.addEditParam.purchase_by = '';
            }
            this.fetchShareholdersByProject(projectId);
        },
        'addEditParam.raw_material_id'() {
            let rawMaterial = this.rawMaterials.find(rawMaterial => rawMaterial.id === this.addEditParam.raw_material_id);
            this.addEditParam.unit_price = rawMaterial !== undefined ? rawMaterial.price : 0;
        },
        'addEditParam.unit_price'() {
            if (parseFloat(this.addEditParam.unit_price) > 0 && parseFloat(this.addEditParam.quantity) > 0) {
                this.addEditParam.amount = parseFloat(this.addEditParam.quantity) * parseFloat(this.addEditParam.unit_price);
            }
        },
        'addEditParam.quantity'() {
            if (parseFloat(this.addEditParam.unit_price) > 0 && parseFloat(this.addEditParam.quantity) > 0) {
                this.addEditParam.amount = parseFloat(this.addEditParam.quantity) * parseFloat(this.addEditParam.unit_price);
            }
        }
    },
    methods: {
        fetchShareholdersByProject(projectId) {
            if (!projectId) {
                this.shareholders = [];
                return;
            }
            ApiService.POST(ApiRoutes.ShareHolder + '/search', {project_id: projectId}, (res) => {
                if (parseInt(res.status) === 200) {
                    this.shareholders = res.data;
                }
            });
        },
        fetchConstruction() {
            ApiService.POST(ApiRoutes.ListConstruction, {limit: 500}, (res) => {
                if (parseInt(res.status) === 200) {
                    this.constructions = res.data.data;
                }
            });
        },
        fetchCostingItem() {
            ApiService.POST(ApiRoutes.CostingItem + '/list', {limit: 100}, (res) => {
                if (parseInt(res.status) === 200) {
                    this.costingItem = res.data.data;
                }
            });
        },
        fetchSpecialExpense() {
            ApiService.POST(ApiRoutes.SpecialExpense + '/list', {limit: 100}, (res) => {
                if (parseInt(res.status) === 200) {
                    this.specialExpense = res.data.data;
                }
            });
        },
        fetchSupplier() {
            ApiService.POST(ApiRoutes.Supplier + '/list', {limit: 100}, (res) => {
                if (parseInt(res.status) === 200) {
                    this.suppliers = res.data.data;
                }
            });
        },
        fetchAssets() {
            ApiService.POST(ApiRoutes.Asset + '/list', {}, (res) => {
                if (parseInt(res.status) === 200) {
                    this.assets = res.data;
                }
            });
        },
        makeFormData(object) {
            let formData = new FormData();
            for (const property in object) {
                if (object[property] !== null && object[property] !== '') {
                    formData.append(property, object[property]);
                }
            }
            return formData;
        },
        addAttachment(e) {
            this.addEditParam.attachment = e.target.files[0];
        },
        fetchRawMaterial() {
            ApiService.POST(ApiRoutes.RawMaterial + '/list', {limit: 500}, (res) => {
                if (parseInt(res.status) === 200) {
                    this.rawMaterials = res.data.data;
                }
            });
        },
        fetchExpenseCategory() {
            ApiService.POST(ApiRoutes.ExpenseCategory + '/list', {limit: 500}, (res) => {
                if (parseInt(res.status) === 200) {
                    this.expenseCategories = res.data.data;
                }
            });
        },
        fetchBank() {
            ApiService.POST(ApiRoutes.Bank + '/list', {limit: 500}, (res) => {
                if (parseInt(res.status) === 200) {
                    this.banks = res.data.data;
                }
            });
        },
        fetchProject() {
            ApiService.POST(ApiRoutes.Project + '/list', {limit: 500}, (res) => {
                if (parseInt(res.status) === 200) {
                    this.projects = res.data.data;
                }
            });
        },
        manage() {
            ApiService.ClearErrorHandler();
            this.loading = true;
            let param = this.makeFormData(this.addEditParam);
            ApiService.POST(ApiRoutes.Expense + '/save', param, (res) => {
                this.loading = false;
                if (parseInt(res.status) === 200) {
                    this.$toast.success(res.message);
                    this.addEditParam = {
                        project_id: '',
                        date: '',
                        payment_method: '',
                        bank_id: '',
                        check_number: '',
                        purchase_by: '',
                        category_id: '',
                        supplier_id: '',
                        attachment: '',
                        raw_material_id: '',
                        unit_price: '',
                        quantity: '',
                        amount: '',
                        remarks: '',
                        special_expense_id: '',
                        costing_item_id: '',
                        construction_id: '',
                        order_by: ''
                    };
                    this.shareholders = [];
                } else {
                    ApiService.ErrorHandler(res.errors);
                }
            });
        }
    },
    created() {
        this.fetchProject();
        this.fetchBank();
        this.fetchExpenseCategory();
        this.fetchRawMaterial();
        this.fetchAssets();
        this.fetchSupplier();
        this.fetchSpecialExpense();
        this.fetchCostingItem();
        this.fetchConstruction();
    }
}
</script>
